export default __webpack_public_path__ + "static/media/courseLanding-socialMedia.59d6fb7a.png";